import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import get from 'lodash.get';

import { AppState } from 'services/types';
import { CalibrationId } from 'services/equipmentSets/types';
import { OwnProps } from './index';
import { selectSprayWorksheetCalibrationsKeyedById } from '../../../../../../selectors';

const selectCalibrationId = (state: AppState, props: OwnProps): CalibrationId =>
    props.calibrationId;

const selectApplicationRate = createDeepEqualSelector(
    selectSprayWorksheetCalibrationsKeyedById,
    selectCalibrationId,
    (calibrationsKeyedById, calibrationId) =>
        get(calibrationsKeyedById, [calibrationId, 'applicationRate'])
);

const makeSelectApplicationRate = (): typeof selectApplicationRate =>
    selectApplicationRate;

export { selectCalibrationId, makeSelectApplicationRate };
